import { render, staticRenderFns } from "./AddBudgetTypeRecognition.vue?vue&type=template&id=35b2c6d2"
import script from "./AddBudgetTypeRecognition.vue?vue&type=script&lang=js"
export * from "./AddBudgetTypeRecognition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports